export const categories = [
  {
    id: "short-video",
    name: "短视频",
    icon: "ri-video-line",
    desc: "记录生活精彩瞬间的短内容，轻松几分钟，看遍人间烟火。",
    subcategories: ["生活记录", "美食探店", "萌宠日常", "创意手工", "城市影像"],
  },
  {
    id: "movie",
    name: "影视剧",
    icon: "ri-film-line",
    desc: "精选院线电影与热播剧集，剧情、动作、文艺一网打尽。",
    subcategories: ["剧情", "动作", "喜剧", "悬疑", "文艺"],
  },
  {
    id: "variety",
    name: "综艺",
    icon: "ri-mic-line",
    desc: "轻松欢乐的综艺节目合集，明星互动与爆笑名场面不断。",
    subcategories: ["真人秀", "选秀", "脱口秀", "美食综艺", "音乐综艺"],
  },
  {
    id: "anime",
    name: "动漫",
    icon: "ri-emotion-happy-line",
    desc: "热血、治愈、奇幻的动漫世界，追更不停歇。",
    subcategories: ["热血", "治愈", "奇幻", "科幻", "日常"],
  },
  {
    id: "documentary",
    name: "纪录片",
    icon: "ri-earth-line",
    desc: "用镜头记录真实世界，自然、人文、美食纪实佳作。",
    subcategories: ["自然", "人文", "美食", "历史", "科技"],
  },
  {
    id: "music",
    name: "音乐",
    icon: "ri-music-2-line",
    desc: "现场演出与音乐短片，感受旋律带来的治愈力量。",
    subcategories: ["民谣", "电音", "流行", "现场", "纯音乐"],
  },
  {
    id: "game",
    name: "游戏",
    icon: "ri-gamepad-line",
    desc: "高光操作、赛事集锦与游戏测评，玩家的快乐基地。",
    subcategories: ["电竞", "主机", "手游", "测评", "攻略"],
  },
  {
    id: "life",
    name: "生活",
    icon: "ri-plant-line",
    desc: "实用的生活技巧与生活方式分享，把日子过得更有质感。",
    subcategories: ["家居", "收纳", "露营", "健身", "旅行"],
  },
];

export const regions = ["全部", "内地", "港台", "日韩", "欧美"];
export const years = ["全部", "2024", "2023", "2022", "2021"];
export const sortOptions = ["综合排序", "最多播放", "最新发布"];

export const videos = [
  {
    id: "v01",
    title: "都市夜归人的一天",
    categoryId: "short-video",
    categoryName: "短视频",
    subcategory: "生活记录",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20short%20video%20still%20of%20a%20young%20office%20worker%20walking%20home%20through%20a%20neon%20lit%20city%20street%20at%20night%2C%20warm%20orange%20street%20lamps%2C%20reflective%20wet%20pavement%2C%20moody%20urban%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20high%20detail%20photography&width=640&height=360&seq=xg-video-01&orientation=landscape",
    duration: "03:24",
    plays: 1280000,
    publishDate: "2024-08-12",
    year: "2024",
    region: "内地",
    cast: "出镜：林小满",
    description: "一个普通上班族的夜晚日常：加班、地铁、便利店、出租屋。看似平淡的片刻，拼凑成城市里无数年轻人的共同记忆。镜头真实记录，愿每个夜归人都被温柔以待。",
    tags: ["生活", "城市", "纪录"],
  },
  {
    id: "v02",
    title: "三分钟教你做夏日冰饮",
    categoryId: "short-video",
    categoryName: "短视频",
    subcategory: "美食探店",
    cover: "https://readdy.ai/api/search-image?query=Refreshing%20summer%20iced%20drink%20close%20up%20on%20a%20light%20marble%20table%2C%20glass%20with%20ice%20cubes%20and%20fresh%20lemon%20slices%2C%20mint%20leaves%2C%20water%20droplets%2C%20bright%20airy%20natural%20light%2C%20clean%20food%20photography%20aesthetic%2C%20high%20detail&width=640&height=360&seq=xg-video-02&orientation=landscape",
    duration: "04:10",
    plays: 980000,
    publishDate: "2024-07-28",
    year: "2024",
    region: "内地",
    cast: "出镜：甜点师阿泽",
    description: "三步搞定三款高颜值夏日冰饮，材料简单、零失败。无论是居家下午茶还是朋友聚会，都能轻松惊艳全场，跟着做就对了。",
    tags: ["美食", "教程", "夏日"],
  },
  {
    id: "v03",
    title: "猫咪的日常迷惑行为大赏",
    categoryId: "short-video",
    categoryName: "短视频",
    subcategory: "萌宠日常",
    cover: "https://readdy.ai/api/search-image?query=Playful%20fluffy%20orange%20cat%20doing%20funny%20antics%20on%20a%20soft%20sunlit%20living%20room%20rug%2C%20bright%20cozy%20home%20interior%2C%20warm%20afternoon%20light%2C%20cute%20pet%20photography%2C%20high%20detail%2C%20joyful%20mood&width=640&height=360&seq=xg-video-03&orientation=landscape",
    duration: "05:32",
    plays: 2450000,
    publishDate: "2024-08-30",
    year: "2024",
    region: "内地",
    cast: "出镜：橘猫团子",
    description: "家里那只猫又双叒叕整活了！从凌晨跑酷到纸箱执念，每一个迷惑瞬间都让人笑到不行。铲屎官们，你们家的主子也这样吗？",
    tags: ["萌宠", "搞笑", "治愈"],
  },
  {
    id: "v04",
    title: "街头美食探店：巷子里的老味道",
    categoryId: "short-video",
    categoryName: "短视频",
    subcategory: "美食探店",
    cover: "https://readdy.ai/api/search-image?query=Nostalgic%20Chinese%20street%20food%20stall%20in%20a%20narrow%20old%20alley%2C%20steaming%20snacks%20and%20skewers%2C%20warm%20red%20lantern%20lights%2C%20evening%20atmosphere%2C%20documentary%20food%20photography%2C%20rich%20appetizing%20detail&width=640&height=360&seq=xg-video-04&orientation=landscape",
    duration: "08:15",
    plays: 760000,
    publishDate: "2023-11-05",
    year: "2023",
    region: "内地",
    cast: "出镜：探店博主老陈",
    description: "藏在老巷子里开了三十年的小店，靠一口汤留住几代街坊。这一次我们走进烟火深处，尝一尝时间沉淀下来的地道味道。",
    tags: ["美食", "探店", "烟火气"],
  },
  {
    id: "v05",
    title: "城市清晨的第一缕阳光（延时摄影）",
    categoryId: "short-video",
    categoryName: "短视频",
    subcategory: "城市影像",
    cover: "https://readdy.ai/api/search-image?query=Time%20lapse%20style%20city%20skyline%20at%20sunrise%2C%20golden%20morning%20light%20streaming%20between%20tall%20buildings%2C%20soft%20mist%20over%20the%20river%2C%20calm%20serene%20atmosphere%2C%20cinematic%20wide%20shot%2C%20high%20detail&width=640&height=360&seq=xg-video-05&orientation=landscape",
    duration: "02:48",
    plays: 1530000,
    publishDate: "2024-09-02",
    year: "2024",
    region: "内地",
    cast: "拍摄：影像工作室",
    description: "为了这三十秒，我们在天台上蹲了整整一夜。当第一缕阳光越过楼群洒向江面，整座城市在晨光中缓缓苏醒，一切都值得。",
    tags: ["延时摄影", "城市", "治愈"],
  },
  {
    id: "v06",
    title: "十分钟画出一只小狐狸",
    categoryId: "short-video",
    categoryName: "短视频",
    subcategory: "创意手工",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20creative%20art%20workspace%20with%20watercolor%20painting%20supplies%20and%20a%20half%20finished%20fox%20illustration%2C%20soft%20natural%20window%20light%2C%20warm%20wooden%20desk%2C%20artistic%20tutorial%20aesthetic%2C%20high%20detail&width=640&height=360&seq=xg-video-06&orientation=landscape",
    duration: "10:02",
    plays: 640000,
    publishDate: "2023-12-18",
    year: "2023",
    region: "内地",
    cast: "讲解：插画师小鹿",
    description: "从打形到上色，手把手带你画出一只灵动的小狐狸。零基础也能跟着完成，画完的成品放进相框，治愈感拉满。",
    tags: ["手工", "绘画", "教程"],
  },
  {
    id: "v07",
    title: "山河故人录",
    categoryId: "movie",
    categoryName: "影视剧",
    subcategory: "剧情",
    cover: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20scene%2F%20a%20lone%20traveler%20standing%20on%20a%20vast%20misty%20mountain%20ridge%20at%20dawn%2C%20dramatic%20golden%20light%2C%20epic%20landscape%2C%20moody%20atmosphere%2C%20film%20grain%2C%20high%20detail&width=640&height=360&seq=xg-video-07&orientation=landscape",
    duration: "112:00",
    plays: 8600000,
    publishDate: "2024-06-20",
    year: "2024",
    region: "内地",
    cast: "主演：程远、苏婉、陈默",
    description: "离家二十年的旅人重回故土，却发现记忆中的山河早已改变。在寻找与告别之间，他重新理解了故乡、亲情与时间。一部关于归来与和解的温情之作。",
    tags: ["剧情", "文艺", "亲情"],
  },
  {
    id: "v08",
    title: "深海追光者",
    categoryId: "movie",
    categoryName: "影视剧",
    subcategory: "悬疑",
    cover: "https://readdy.ai/api/search-image?query=Deep%20blue%20underwater%20ocean%20scene%20with%20light%20rays%20piercing%20from%20the%20surface%2C%20scientific%20submarine%20silhouette%2C%20mysterious%20atmospheric%20mood%2C%20cinematic%20movie%20still%2C%20high%20detail&width=640&height=360&seq=xg-video-08&orientation=landscape",
    duration: "98:00",
    plays: 5300000,
    publishDate: "2023-09-14",
    year: "2023",
    region: "欧美",
    cast: "主演：艾琳·沃克、马克·里德",
    description: "一支深海科考队在下潜万米时探测到异常信号，随着调查深入，一段被尘封的科学秘密逐渐浮出水面。紧张窒息的悬疑之旅，黑暗深处究竟藏着什么？",
    tags: ["悬疑", "科幻", "冒险"],
  },
  {
    id: "v09",
    title: "老街咖啡馆",
    categoryId: "movie",
    categoryName: "影视剧",
    subcategory: "文艺",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20nostalgic%20small%20cafe%20on%20an%20old%20town%20street%2C%20warm%20amber%20interior%20light%2C%20vintage%20wooden%20furniture%2C%20soft%20rain%20outside%20the%20window%2C%20melancholic%20film%20still%2C%20high%20detail&width=640&height=360&seq=xg-video-09&orientation=landscape",
    duration: "105:00",
    plays: 3100000,
    publishDate: "2024-05-30",
    year: "2024",
    region: "港台",
    cast: "主演：周慕青、阿凯",
    description: "一间开了四十年的咖啡馆，见证了无数人的聚散离合。新掌柜到来后，用一杯杯手冲咖啡，慢慢拼凑起属于这条老街的故事与温度。",
    tags: ["文艺", "治愈", "人生"],
  },
  {
    id: "v10",
    title: "逆风飞行",
    categoryId: "movie",
    categoryName: "影视剧",
    subcategory: "动作",
    cover: "https://readdy.ai/api/search-image?query=Dramatic%20action%20movie%20still%20of%20a%20pilot%20silhouette%20against%20a%20stormy%20sky%2C%20aircraft%20wing%20in%20foreground%2C%20dark%20clouds%20and%20lightning%2C%20intense%20cinematic%20atmosphere%2C%20high%20detail&width=640&height=360&seq=xg-video-10&orientation=landscape",
    duration: "121:00",
    plays: 6700000,
    publishDate: "2022-10-08",
    year: "2022",
    region: "内地",
    cast: "主演：雷扬、乔安",
    description: "退役飞行员临危受命，带领机组执行一次充满变数的飞行任务。在气流、雷电与人心之间，他们能否化险为夷？一部肾上腺素飙升的高空动作大片。",
    tags: ["动作", "冒险", "燃"],
  },
  {
    id: "v11",
    title: "无声的证词",
    categoryId: "movie",
    categoryName: "影视剧",
    subcategory: "悬疑",
    cover: "https://readdy.ai/api/search-image?query=Moody%20crime%20thriller%20scene%2C%20detective%20studying%20evidence%20photos%20under%20a%20single%20desk%20lamp%20in%20a%20dim%20office%2C%20rain%20on%20window%2C%20tense%20mysterious%20atmosphere%2C%20cinematic%20film%20still%2C%20high%20detail&width=640&height=360&seq=xg-video-11&orientation=landscape",
    duration: "108:00",
    plays: 4200000,
    publishDate: "2023-07-22",
    year: "2023",
    region: "日韩",
    cast: "主演：岩井透、李秀妍",
    description: "一桩看似普通的案件，唯一的目击者却无法开口。侦探凭借细微的线索层层推进，在沉默的证词中还原出令人震惊的真相。",
    tags: ["悬疑", "犯罪", "推理"],
  },
  {
    id: "v12",
    title: "周末大派对 第五季",
    categoryId: "variety",
    categoryName: "综艺",
    subcategory: "真人秀",
    cover: "https://readdy.ai/api/search-image?query=Vibrant%20colorful%20studio%20stage%20with%20party%20lights%20and%20confetti%2C%20energetic%20game%20show%20set%2C%20playful%20joyful%20atmosphere%2C%20bright%20saturated%20colors%2C%20high%20detail%20photography&width=640&height=360&seq=xg-video-12&orientation=landscape",
    duration: "72:00",
    plays: 9100000,
    publishDate: "2024-09-06",
    year: "2024",
    region: "内地",
    cast: "常驻：快乐家族、飞行嘉宾",
    description: "全新一季欢乐回归！每期邀请不同嘉宾挑战花样游戏，笑点密集、名场面不断。周末放松解压的快乐源泉，就等你一起来嗨。",
    tags: ["综艺", "搞笑", "真人秀"],
  },
  {
    id: "v13",
    title: "我们的旅行日记",
    categoryId: "variety",
    categoryName: "综艺",
    subcategory: "真人秀",
    cover: "https://readdy.ai/api/search-image?query=Sunny%20scenic%20road%20trip%20vibe%20with%20friends%20laughing%20by%20a%20camper%20van%20on%20a%20mountain%20road%2C%20golden%20afternoon%20light%2C%20joyful%20travel%20atmosphere%2C%20warm%20tones%2C%20high%20detail&width=640&height=360&seq=xg-video-13&orientation=landscape",
    duration: "65:00",
    plays: 5800000,
    publishDate: "2024-08-18",
    year: "2024",
    region: "内地",
    cast: "固定嘉宾：五人行",
    description: "五位好友开着一辆房车穿越山川湖海，沿途记录旅途中的温暖与欢笑。没有剧本，只有真实发生的友情时刻。",
    tags: ["综艺", "旅行", "治愈"],
  },
  {
    id: "v14",
    title: "厨房的战争",
    categoryId: "variety",
    categoryName: "综艺",
    subcategory: "美食综艺",
    cover: "https://readdy.ai/api/search-image?query=Bright%20modern%20pro%20kitchen%20cooking%20competition%20set%2C%20chefs%20plating%20signature%20dishes%2C%20colorful%20fresh%20ingredients%2C%20warm%20studio%20lighting%2C%20high%20detail%20food%20photography&width=640&height=360&seq=xg-video-14&orientation=landscape",
    duration: "78:00",
    plays: 4400000,
    publishDate: "2023-10-25",
    year: "2023",
    region: "内地",
    cast: "评委：名厨团队",
    description: "来自各地的厨艺高手同台竞技，用有限食材在限定时间内完成创意料理。刀光火影之间，考验的不只是厨艺，更是心态与灵感。",
    tags: ["综艺", "美食", "竞技"],
  },
  {
    id: "v15",
    title: "明星运动会 2024",
    categoryId: "variety",
    categoryName: "综艺",
    subcategory: "选秀",
    cover: "https://readdy.ai/api/search-image?query=Large%20outdoor%20sports%20field%20event%20under%20a%20clear%20blue%20sky%2C%20colorful%20team%20flags%2C%20excited%20crowd%2C%20energetic%20competition%20atmosphere%2C%20bright%20daylight%2C%20high%20detail&width=640&height=360&seq=xg-video-15&orientation=landscape",
    duration: "88:00",
    plays: 11200000,
    publishDate: "2024-09-10",
    year: "2024",
    region: "内地",
    cast: "参演：全明星阵容",
    description: "百位明星齐聚赛场，展开田径、拔河、接力等多项角逐。汗水与拼搏齐飞，名场面与感动同在，这个夏天一起为热爱加油！",
    tags: ["综艺", "运动", "明星"],
  },
  {
    id: "v16",
    title: "音乐现场：夏日歌会",
    categoryId: "variety",
    categoryName: "综艺",
    subcategory: "音乐综艺",
    cover: "https://readdy.ai/api/search-image?query=Live%20outdoor%20music%20concert%20stage%20at%20summer%20night%2C%20stage%20lights%20and%20glowing%20crowd%2C%20warm%20festive%20atmosphere%2C%20cinematic%20wide%20shot%2C%20high%20detail&width=640&height=360&seq=xg-video-16&orientation=landscape",
    duration: "60:00",
    plays: 3700000,
    publishDate: "2023-08-12",
    year: "2023",
    region: "港台",
    cast: "演唱：夏日歌会群星",
    description: "一整晚的现场演出，把夏天的热烈全部唱给你听。从抒情金曲到热血摇滚，跟着旋律一起挥动双手，感受音乐最纯粹的力量。",
    tags: ["综艺", "音乐", "现场"],
  },
  {
    id: "v17",
    title: "星海物语",
    categoryId: "anime",
    categoryName: "动漫",
    subcategory: "科幻",
    cover: "https://readdy.ai/api/search-image?query=Anime%20style%20scene%20of%20a%20young%20space%20explorer%20gazing%20at%20a%20vast%20colorful%20nebula%2C%20spaceship%20silhouette%2C%20dreamy%20starry%20sky%2C%20vibrant%20sci%20fi%20illustration%2C%20high%20detail&width=640&height=360&seq=xg-video-17&orientation=landscape",
    duration: "24:00",
    plays: 6200000,
    publishDate: "2024-07-04",
    year: "2024",
    region: "日韩",
    cast: "配音：星野遥、林澈",
    description: "在被星海包围的遥远未来，少年驾驶飞船踏上寻找故乡的旅程。每一颗星球都有故事，每一次相遇都是命运的指引。热血成长冒险番。",
    tags: ["动漫", "科幻", "热血"],
  },
  {
    id: "v18",
    title: "小镇奇想录",
    categoryId: "anime",
    categoryName: "动漫",
    subcategory: "治愈",
    cover: "https://readdy.ai/api/search-image?query=Warm%20cozy%20anime%20illustration%20of%20a%20small%20countryside%20town%20at%20sunset%2C%20cobblestone%20street%20and%20little%20shops%2C%20soft%20pastel%20colors%2C%20gentle%20nostalgic%20mood%2C%20high%20detail&width=640&height=360&seq=xg-video-18&orientation=landscape",
    duration: "22:00",
    plays: 3900000,
    publishDate: "2024-06-16",
    year: "2024",
    region: "内地",
    cast: "配音：小满、阿吉",
    description: "一座不起眼的小镇上，住着会魔法的邻居、爱做梦的少女和开书店的猫。日常的缝隙里，藏着最温柔的奇想。治愈系日常动画。",
    tags: ["动漫", "治愈", "日常"],
  },
  {
    id: "v19",
    title: "机甲少年",
    categoryId: "anime",
    categoryName: "动漫",
    subcategory: "热血",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20mecha%20anime%20scene%20of%20a%20giant%20robot%20in%20an%20industrial%20city%2C%20dramatic%20lighting%20and%20sparks%2C%20epic%20action%20atmosphere%2C%20vibrant%20illustration%2C%20high%20detail&width=640&height=360&seq=xg-video-19&orientation=landscape",
    duration: "25:00",
    plays: 5100000,
    publishDate: "2023-11-20",
    year: "2023",
    region: "日韩",
    cast: "配音：苍井翔、佐仓凛",
    description: "少年们驾驶机甲守护城市，面对未知的敌人与内心的恐惧。友情、信念与成长的碰撞，燃到最后一秒。",
    tags: ["动漫", "热血", "机甲"],
  },
  {
    id: "v20",
    title: "舌尖上的四季",
    categoryId: "documentary",
    categoryName: "纪录片",
    subcategory: "美食",
    cover: "https://readdy.ai/api/search-image?query=Documentary%20style%20scene%20of%20a%20rustic%20farm%20table%20filled%20with%20seasonal%20fresh%20dishes%2C%20warm%20natural%20light%2C%20rural%20Chinese%20kitchen%2C%20rich%20appetizing%20food%20photography%2C%20high%20detail&width=640&height=360&seq=xg-video-20&orientation=landscape",
    duration: "48:00",
    plays: 7300000,
    publishDate: "2024-04-22",
    year: "2024",
    region: "内地",
    cast: "解说：人文影像团队",
    description: "跟随四季更替，走进不同地域的餐桌。从春天的第一口鲜到冬夜的暖汤，食物背后是土地、时间与人的深情连接。",
    tags: ["纪录片", "美食", "人文"],
  },
  {
    id: "v21",
    title: "蓝色星球：海洋纪事",
    categoryId: "documentary",
    categoryName: "纪录片",
    subcategory: "自然",
    cover: "https://readdy.ai/api/search-image?query=Breathtaking%20underwater%20documentary%20scene%20of%20coral%20reef%20and%20tropical%20fish%20in%20crystal%20clear%20blue%20water%2C%20sunlight%20rays%2C%20vivid%20nature%20photography%2C%20high%20detail&width=640&height=360&seq=xg-video-21&orientation=landscape",
    duration: "52:00",
    plays: 4900000,
    publishDate: "2023-06-18",
    year: "2023",
    region: "欧美",
    cast: "解说：大卫·艾登堡团队",
    description: "潜入蔚蓝深处，见证海洋生命的壮丽与脆弱。从珊瑚礁到深海沟，这部纪录片带你重新认识覆盖地球七成的神秘世界。",
    tags: ["纪录片", "自然", "海洋"],
  },
  {
    id: "v22",
    title: "古城手艺人",
    categoryId: "documentary",
    categoryName: "纪录片",
    subcategory: "人文",
    cover: "https://readdy.ai/api/search-image?query=Documentary%20scene%20of%20an%20elderly%20artisan%20crafting%20traditional%20handicraft%20in%20an%20old%20workshop%2C%20warm%20dusty%20light%2C%20wooden%20tools%2C%20heritage%20atmosphere%2C%20high%20detail&width=640&height=360&seq=xg-video-22&orientation=landscape",
    duration: "45:00",
    plays: 2800000,
    publishDate: "2023-09-30",
    year: "2023",
    region: "内地",
    cast: "解说：手艺纪录团队",
    description: "在快节奏的时代，仍有人愿意用一生打磨一门手艺。走进古城手艺人，倾听他们与工具、时光和传承的故事。",
    tags: ["纪录片", "人文", "传承"],
  },
  {
    id: "v23",
    title: "民谣现场：城市与远方",
    categoryId: "music",
    categoryName: "音乐",
    subcategory: "民谣",
    cover: "https://readdy.ai/api/search-image?query=Intimate%20small%20acoustic%20music%20set%20on%20a%20rooftop%20at%20dusk%2C%20singer%20with%20guitar%2C%20string%20lights%2C%20warm%20cozy%20urban%20atmosphere%2C%20high%20detail&width=640&height=360&seq=xg-video-23&orientation=landscape",
    duration: "55:00",
    plays: 3300000,
    publishDate: "2024-08-24",
    year: "2024",
    region: "内地",
    cast: "演唱：旅人乐队",
    description: "一把木吉他，一段关于城市与远方的故事。旅人乐队在自己的小舞台上，唱出漂泊者的温柔与倔强，适合一个人静静聆听。",
    tags: ["音乐", "民谣", "现场"],
  },
  {
    id: "v24",
    title: "电音之夜 2024",
    categoryId: "music",
    categoryName: "音乐",
    subcategory: "电音",
    cover: "https://readdy.ai/api/search-image?query=Electric%20night%20club%20music%20festival%20with%20neon%20lights%20and%20laser%20beams%2C%20DJ%20booth%2C%20energetic%20crowd%2C%20vibrant%20colorful%20atmosphere%2C%20high%20detail&width=640&height=360&seq=xg-video-24&orientation=landscape",
    duration: "62:00",
    plays: 4100000,
    publishDate: "2024-09-01",
    year: "2024",
    region: "欧美",
    cast: "DJ：Neon Pulse",
    description: "整晚不停歇的电音派对，用最炸的节拍点燃夜晚。灯光、音浪与人群共振，带你体验一场纯粹的能量释放。",
    tags: ["音乐", "电音", "派对"],
  },
  {
    id: "v25",
    title: "王者高光时刻合集",
    categoryId: "game",
    categoryName: "游戏",
    subcategory: "电竞",
    cover: "https://readdy.ai/api/search-image?query=Esports%20gaming%20scene%20with%20neon%20purple%20and%20cyan%20lights%2C%20keyboard%20and%20headset%2C%20intense%20competitive%20gaming%20atmosphere%2C%20dark%20moody%20setup%2C%20high%20detail&width=640&height=360&seq=xg-video-25&orientation=landscape",
    duration: "18:00",
    plays: 8900000,
    publishDate: "2024-08-28",
    year: "2024",
    region: "内地",
    cast: "解说：电竞小王",
    description: "本周峡谷最精彩的操作全都在这了！五杀、极限翻盘、神仙走位，配合激情解说，一次看过瘾。",
    tags: ["游戏", "电竞", "高光"],
  },
  {
    id: "v26",
    title: "独立游戏测评：像素世界",
    categoryId: "game",
    categoryName: "游戏",
    subcategory: "测评",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20retro%20pixel%20art%20game%20scene%20on%20a%20monitor%20in%20a%20dim%20room%2C%20colorful%20pixel%20landscape%2C%20warm%20screen%20glow%2C%20nostalgic%20gamer%20setup%2C%20high%20detail&width=640&height=360&seq=xg-video-26&orientation=landscape",
    duration: "26:00",
    plays: 2600000,
    publishDate: "2023-12-02",
    year: "2023",
    region: "内地",
    cast: "解说：游戏阿哲",
    description: "一款画风治愈的像素独立游戏，玩法简单却让人上头。从画面、音乐到剧情，带你完整体验这款小体量佳作的独特魅力。",
    tags: ["游戏", "测评", "独立游戏"],
  },
  {
    id: "v27",
    title: "极简主义收纳指南",
    categoryId: "life",
    categoryName: "生活",
    subcategory: "收纳",
    cover: "https://readdy.ai/api/search-image?query=Minimalist%20tidy%20home%20interior%20with%20organized%20wooden%20shelves%20and%20storage%20baskets%2C%20soft%20natural%20light%2C%20clean%20warm%20Scandinavian%20style%2C%20high%20detail&width=640&height=360&seq=xg-video-27&orientation=landscape",
    duration: "12:00",
    plays: 5500000,
    publishDate: "2024-07-15",
    year: "2024",
    region: "内地",
    cast: "出镜：整理师晓雯",
    description: "东西越少，生活越轻盈。整理师带你从衣柜到厨房，一步步打造清爽有序的极简空间，收纳从此不再是难题。",
    tags: ["生活", "收纳", "家居"],
  },
  {
    id: "v28",
    title: "一个人的露营日记",
    categoryId: "life",
    categoryName: "生活",
    subcategory: "露营",
    cover: "https://readdy.ai/api/search-image?query=Peaceful%20solo%20camping%20scene%20with%20a%20small%20tent%20by%20a%20lake%20at%20dusk%2C%20warm%20lantern%20glow%2C%20calm%20nature%20surroundings%2C%20cozy%20quiet%20atmosphere%2C%20high%20detail&width=640&height=360&seq=xg-video-28&orientation=landscape",
    duration: "16:00",
    plays: 3400000,
    publishDate: "2023-10-12",
    year: "2023",
    region: "内地",
    cast: "出镜：露营爱好者阿岚",
    description: "背上行囊，一个人去湖边露营。生火、煮饭、看星星，独处的时光让紧绷的心慢慢放松下来。愿你也找到属于自己的那片宁静。",
    tags: ["生活", "露营", "治愈"],
  },
  {
    id: "v29",
    title: "迷雾之城",
    categoryId: "movie",
    categoryName: "影视剧",
    subcategory: "悬疑",
    cover: "https://readdy.ai/api/search-image?query=Moody%20foggy%20city%20street%20at%20night%20with%20glowing%20street%20lamps%2C%20a%20lone%20figure%20walking%20through%20dense%20mist%2C%20mysterious%20cinematic%20thriller%20atmosphere%2C%20high%20detail%20film%20still&width=640&height=360&seq=xg-video-29&orientation=landscape",
    duration: "118:00",
    plays: 7800000,
    publishDate: "2024-03-15",
    year: "2024",
    region: "内地",
    cast: "主演：顾城、白薇",
    description: "连续失踪案让整座城市陷入迷雾。当年轻警探发现所有线索都指向同一个被遗忘的旧案，真相与谎言之间的界限开始模糊不清。",
    tags: ["悬疑", "犯罪", "剧情"],
  },
  {
    id: "v30",
    title: "春日告白",
    categoryId: "movie",
    categoryName: "影视剧",
    subcategory: "文艺",
    cover: "https://readdy.ai/api/search-image?query=Soft%20romantic%20spring%20scene%20with%20cherry%20blossoms%20and%20warm%20sunlight%2C%20a%20couple%20silhouette%20on%20a%20quiet%20path%2C%20dreamy%20pastel%20cinematic%20mood%2C%20high%20detail&width=640&height=360&seq=xg-video-30&orientation=landscape",
    duration: "96:00",
    plays: 4100000,
    publishDate: "2024-04-02",
    year: "2024",
    region: "港台",
    cast: "主演：林晚、陈屿",
    description: "一次迟到了十年的告白，一段被时间反复擦拭的心事。在樱花纷飞的春天，两个人终于有机会重新说出那句藏在心底的话。",
    tags: ["文艺", "爱情", "治愈"],
  },
  {
    id: "v31",
    title: "最后一班地铁",
    categoryId: "movie",
    categoryName: "影视剧",
    subcategory: "剧情",
    cover: "https://readdy.ai/api/search-image?query=Empty%20modern%20subway%20platform%20at%20late%20night%20with%20fluorescent%20lights%2C%20a%20lone%20passenger%20waiting%2C%20quiet%20melancholic%20urban%20atmosphere%2C%20cinematic%20still%2C%20high%20detail&width=640&height=360&seq=xg-video-31&orientation=landscape",
    duration: "102:00",
    plays: 3900000,
    publishDate: "2022-08-19",
    year: "2022",
    region: "内地",
    cast: "主演：周航、苏芮",
    description: "末班地铁上，六个陌生人因一场意外被迫同行。深夜的车厢里，他们交换着各自的故事，也慢慢放下一整天的疲惫与委屈。",
    tags: ["剧情", "都市", "人生"],
  },
  {
    id: "v32",
    title: "荒野信号",
    categoryId: "movie",
    categoryName: "影视剧",
    subcategory: "动作",
    cover: "https://readdy.ai/api/search-image?query=Rugged%20desert%20canyon%20landscape%20at%20sunset%20with%20an%20off%20road%20vehicle%2C%20dramatic%20orange%20sky%2C%20gritty%20action%20adventure%20atmosphere%2C%20cinematic%20wide%20shot%2C%20high%20detail&width=640&height=360&seq=xg-video-32&orientation=landscape",
    duration: "110:00",
    plays: 5600000,
    publishDate: "2023-05-11",
    year: "2023",
    region: "欧美",
    cast: "主演：杰克·莫尔、莉娜·凯恩",
    description: "一支勘探队深入无人荒野，却意外接收到一段不该存在的信号。当补给耗尽、前路被封，他们必须做出信任还是保命的选择。",
    tags: ["动作", "冒险", "悬疑"],
  },
  {
    id: "v33",
    title: "深夜食堂对谈",
    categoryId: "variety",
    categoryName: "综艺",
    subcategory: "脱口秀",
    cover: "https://readdy.ai/api/search-image?query=Warm%20cozy%20late%20night%20talk%20show%20set%20with%20soft%20amber%20lighting%2C%20small%20bar%20counter%2C%20two%20stools%2C%20intimate%20relaxed%20atmosphere%2C%20high%20detail&width=640&height=360&seq=xg-video-33&orientation=landscape",
    duration: "58:00",
    plays: 4700000,
    publishDate: "2024-07-09",
    year: "2024",
    region: "内地",
    cast: "主持：阿星、特邀嘉宾",
    description: "深夜的小酒馆里，主理人与嘉宾围坐一桌，聊工作、聊生活、聊那些白天说不出口的心事。有笑有泪，越夜越真实。",
    tags: ["综艺", "脱口秀", "治愈"],
  },
  {
    id: "v34",
    title: "极限挑战营",
    categoryId: "variety",
    categoryName: "综艺",
    subcategory: "真人秀",
    cover: "https://readdy.ai/api/search-image?query=Outdoor%20adventure%20challenge%20course%20in%20a%20green%20mountain%20forest%2C%20team%20obstacle%20race%2C%20bright%20daylight%2C%20energetic%20competition%20atmosphere%2C%20high%20detail&width=640&height=360&seq=xg-video-34&orientation=landscape",
    duration: "82:00",
    plays: 6300000,
    publishDate: "2023-06-30",
    year: "2023",
    region: "内地",
    cast: "常驻：挑战家族",
    description: "八位嘉宾组成两队，在野外完成层层关卡挑战。体力、智慧与团队默契的全面较量，看谁能笑到最后。",
    tags: ["综艺", "真人秀", "户外"],
  },
  {
    id: "v35",
    title: "说唱新世代",
    categoryId: "variety",
    categoryName: "综艺",
    subcategory: "音乐综艺",
    cover: "https://readdy.ai/api/search-image?query=Urban%20hip%20hop%20stage%20with%20neon%20graffiti%20walls%20and%20spotlights%2C%20microphone%20on%20stand%2C%20street%20culture%20atmosphere%2C%20vibrant%20high%20detail&width=640&height=360&seq=xg-video-35&orientation=landscape",
    duration: "76:00",
    plays: 5400000,
    publishDate: "2024-05-21",
    year: "2024",
    region: "内地",
    cast: "导师：说唱前辈团",
    description: "一群怀揣梦想的年轻人站上舞台，用flow讲述自己的故事。从街头到聚光灯下，每一段verse都是真实生活的回响。",
    tags: ["综艺", "音乐", "说唱"],
  },
  {
    id: "v36",
    title: "天台花园改造记",
    categoryId: "short-video",
    categoryName: "短视频",
    subcategory: "生活记录",
    cover: "https://readdy.ai/api/search-image?query=Lush%20rooftop%20garden%20transformation%20with%20potted%20plants%20and%20warm%20string%20lights%2C%20city%20skyline%20in%20background%2C%20golden%20hour%20light%2C%20high%20detail%20lifestyle%20photography&width=640&height=360&seq=xg-video-36&orientation=landscape",
    duration: "07:20",
    plays: 1120000,
    publishDate: "2024-06-08",
    year: "2024",
    region: "内地",
    cast: "出镜：园艺爱好者小禾",
    description: "把闲置的屋顶改造成一片小花园，从搬土到种花只用了三天。当第一朵花开的时候，整座城市的天际线都变得温柔了。",
    tags: ["生活", "园艺", "改造"],
  },
  {
    id: "v37",
    title: "一分钟学会胶片调色",
    categoryId: "short-video",
    categoryName: "短视频",
    subcategory: "创意手工",
    cover: "https://readdy.ai/api/search-image?query=Creative%20photo%20editing%20workstation%20with%20a%20monitor%20showing%20warm%20film%20color%20grading%2C%20camera%20and%20lens%20on%20desk%2C%20soft%20studio%20light%2C%20high%20detail&width=640&height=360&seq=xg-video-37&orientation=landscape",
    duration: "02:35",
    plays: 890000,
    publishDate: "2024-09-05",
    year: "2024",
    region: "内地",
    cast: "讲解：摄影师阿岩",
    description: "不用复杂插件，一分钟教你调出复古胶片感。掌握这三个关键参数，你的照片也能瞬间充满故事感，新手友好。",
    tags: ["教程", "摄影", "调色"],
  },
  {
    id: "v38",
    title: "街头钢琴师的即兴演奏",
    categoryId: "short-video",
    categoryName: "短视频",
    subcategory: "城市影像",
    cover: "https://readdy.ai/api/search-image?query=Street%20pianist%20playing%20an%20upright%20piano%20in%20a%20busy%20city%20plaza%2C%20passersby%20stopping%20to%20listen%2C%20warm%20afternoon%20light%2C%20emotional%20urban%20atmosphere%2C%20high%20detail&width=640&height=360&seq=xg-video-38&orientation=landscape",
    duration: "06:12",
    plays: 1680000,
    publishDate: "2023-10-28",
    year: "2023",
    region: "欧美",
    cast: "演奏：街头音乐人 Leo",
    description: "一架被遗弃在街角的旧钢琴，遇见了一位路过的音乐人。当旋律响起，匆忙的行人纷纷停下脚步，城市在此刻安静了下来。",
    tags: ["音乐", "城市", "治愈"],
  },
  {
    id: "v39",
    title: "云上邮差",
    categoryId: "anime",
    categoryName: "动漫",
    subcategory: "奇幻",
    cover: "https://readdy.ai/api/search-image?query=Whimsical%20anime%20scene%20of%20a%20flying%20postman%20on%20a%20small%20airship%20among%20floating%20clouds%20and%20sky%20islands%2C%20soft%20pastel%20colors%2C%20dreamy%20fantasy%20illustration%2C%20high%20detail&width=640&height=360&seq=xg-video-39&orientation=landscape",
    duration: "23:00",
    plays: 3600000,
    publishDate: "2024-08-05",
    year: "2024",
    region: "内地",
    cast: "配音：小云、老陈",
    description: "在漂浮于云海之上的世界，邮差乘着飞艇为各个天空岛屿送信。每一封信背后，都是一段等待被送达的心意。奇幻治愈新番。",
    tags: ["动漫", "奇幻", "治愈"],
  },
  {
    id: "v40",
    title: "复古像素冒险 全流程",
    categoryId: "game",
    categoryName: "游戏",
    subcategory: "主机",
    cover: "https://readdy.ai/api/search-image?query=Retro%20pixel%20art%20adventure%20game%20world%20on%20a%20screen%2C%20colorful%20pixel%20landscape%20with%20hero%20character%2C%20nostalgic%20cozy%20gaming%20setup%20with%20warm%20lighting%2C%20high%20detail&width=640&height=360&seq=xg-video-40&orientation=landscape",
    duration: "42:00",
    plays: 2100000,
    publishDate: "2024-04-18",
    year: "2024",
    region: "内地",
    cast: "解说：游戏阿哲",
    description: "带你完整通关这款复古像素冒险游戏。从隐藏道具到隐藏结局，全程无尿点解说，情怀拉满的一次怀旧之旅。",
    tags: ["游戏", "主机", "攻略"],
  },
];

export const heroSlides = [
  {
    id: "hero-01",
    videoId: "v15",
    title: "明星运动会 2024",
    subtitle: "百位明星同场竞技，热血一夏",
    image: "https://readdy.ai/api/search-image?query=Epic%20wide%20cinematic%20shot%20of%20a%20bright%20sunny%20sports%20stadium%20filled%20with%20colorful%20flags%20and%20enthusiastic%20crowd%2C%20dramatic%20sky%2C%20vibrant%20energetic%20atmosphere%2C%20high%20detail%20photography&width=1600&height=900&seq=xg-hero-01&orientation=landscape",
  },
  {
    id: "hero-02",
    videoId: "v07",
    title: "山河故人录",
    subtitle: "一场关于归来与和解的温情之作",
    image: "https://readdy.ai/api/search-image?query=Epic%20cinematic%20landscape%20of%20misty%20mountain%20ranges%20at%20golden%20sunrise%2C%20a%20lone%20traveler%20silhouette%20on%20a%20ridge%2C%20warm%20dramatic%20light%2C%20moody%20atmospheric%20film%20still%2C%20high%20detail&width=1600&height=900&seq=xg-hero-02&orientation=landscape",
  },
  {
    id: "hero-03",
    videoId: "v20",
    title: "舌尖上的四季",
    subtitle: "跟随四季更替，走进餐桌的故事",
    image: "https://readdy.ai/api/search-image?query=Warm%20rustic%20documentary%20scene%20of%20a%20long%20table%20full%20of%20seasonal%20dishes%20under%20soft%20golden%20light%2C%20rural%20kitchen%20background%2C%20rich%20appetizing%20food%20photography%2C%20high%20detail&width=1600&height=900&seq=xg-hero-03&orientation=landscape",
  },
  {
    id: "hero-04",
    videoId: "v17",
    title: "星海物语",
    subtitle: "少年与星海的成长冒险",
    image: "https://readdy.ai/api/search-image?query=Stunning%20anime%20style%20space%20scene%20with%20a%20vast%20colorful%20nebula%20and%20glowing%20stars%2C%20small%20spaceship%20in%20the%20distance%2C%20dreamy%20vibrant%20sci%20fi%20illustration%2C%20high%20detail&width=1600&height=900&seq=xg-hero-04&orientation=landscape",
  },
  {
    id: "hero-05",
    videoId: "v12",
    title: "周末大派对 第五季",
    subtitle: "欢乐回归，名场面不断",
    image: "https://readdy.ai/api/search-image?query=Vibrant%20colorful%20stage%20with%20party%20lights%20and%20confetti%20falling%2C%20energetic%20celebration%20atmosphere%2C%20bright%20saturated%20playful%20colors%2C%20high%20detail%20photography&width=1600&height=900&seq=xg-hero-05&orientation=landscape",
  },
];